import { type MetaFunction } from '@remix-run/node'
import Content from './terms-of-service.mdx'

export const meta: MetaFunction = () => {
	return [
		{
			title: 'Terms of Service | Intuizen',
			description: 'Detailed terms of service for Intuizen application.',
		},
	]
}

export default function TermsOfServiceRoute() {
	return (
		<div className="container prose">
			<Content />
		</div>
	)
}
